const TotalMonthlyPriceWithFeeNoticeMappingToURL = ({ replaceText = '', replaceUrl = '' }) => ({
  replaceText: String(replaceText),
  replaceUrl: String(replaceUrl),
});

const TotalMonthlyPriceWithFeeNotice = ({ isEligible = false, id = '', text = '', mappings = [] } = {}) => ({
  isEligible: Boolean(isEligible),
  id: String(id),
  text: String(text),
  mappings: mappings.map(TotalMonthlyPriceWithFeeNoticeMappingToURL),
});

export default TotalMonthlyPriceWithFeeNotice;

export type TotalMonthlyPriceWithFeeNoticeProps = ReturnType<typeof TotalMonthlyPriceWithFeeNotice>;
